<template>
  <div v-if="effectiveType === EFFECTIVE_TYPES.SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.CASH_BASIS">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Cash Basis
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.PAID" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.REFUNDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.ACCRUAL">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Accrual
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_SALES" />
      <q-icon
        class="col-auto q-mx-xs"
        name="add"
        color="grey-8"
        size="md"
      />
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_SALES" />
      <q-icon
        class="col-auto q-mx-xs"
        name="add"
        color="grey-8"
        size="md"
      />
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.PAST_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.PAST_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.ATTENDANCE">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Attendance
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_SALES" />
      <q-icon
        class="col-auto q-mx-xs"
        name="add"
        color="grey-8"
        size="md"
      />
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_SALES" />
      <q-icon
        class="col-auto q-mx-xs"
        name="add"
        color="grey-8"
        size="md"
      />
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.RETROACTIVE_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.RETROACTIVE_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.CURRENT_SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Current Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.MATURING_SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Maturing Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.MATURING_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.FUTURE_SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Future Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.FUTURE_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.FUTURE_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.PAST_SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Past Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.PAST_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.PAST_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.RETROACTIVE_SALES">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Retroactive Sales
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.RETROACTIVE_SALES" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.RETROACTIVE_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.CURRENT_PAYMENTS">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Current Payments
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_PAYMENTS" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.REFUNDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.UNPAID_PLACEMENTS">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Unpaid Placements
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_UNPAID_PLACEMENTS" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_UNPAID_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.PAST_UNPAID_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.PAID_PAST_PLACEMENTS">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Pay Past Placements
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.PAID_PAST_PLACEMENTS" />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>

  <div v-else-if="effectiveType === EFFECTIVE_TYPES.ACCOUNTS_RECEIVABLE">
    <div class="row q-mb-lg">
      <div class="col-auto text-h5">
        Accounts Receivable
      </div>
      <q-space />
      <q-toggle
        v-if="showVoidControl"
        v-model="showVoid"
        label="Show Void Handling"
      >
        <q-tooltip>Show how voids are handled for this Effective Type</q-tooltip>
      </q-toggle>
    </div>
    <div class="row justify-center items-center">
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.PAST_UNPAID_PLACEMENTS" />
      <q-icon
        class="col-auto q-mx-xs"
        name="add"
        color="grey-8"
        size="md"
      />
      <effective-scenario :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_UNPAID_PLACEMENTS" />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.PAST_UNPAID_VOIDS"
      />
      <q-icon
        v-if="showVoid"
        class="col-auto q-mx-xs"
        name="remove"
        color="grey-8"
        size="md"
      />
      <effective-scenario
        v-if="showVoid"
        :effective-scenario="EFFECTIVE_SCENARIOS.CURRENT_UNPAID_VOIDS"
      />
    </div>
    <div class="text-body2 q-mt-lg">
      {{ EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS[effectiveType] }}
    </div>
  </div>
</template>

<script>
import { EFFECTIVE_TYPES } from 'src/models/accounting/AccountSource'
import { EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS } from 'src/models/accounting/EffectiveTypeDescriptions'
import EffectiveScenario, { EFFECTIVE_SCENARIOS } from 'src/modules/admin/effective-type/EffectiveScenario'

export default {
  name: 'EffectiveTypeDetail',
  components: { EffectiveScenario },
  props: {
    effectiveType: {
      type: String,
      required: false,
      default: EFFECTIVE_TYPES.SALES
    },
    showVoidControl: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      showVoid: true
    }
  },
  created () {
    _.extend(this, {
      EFFECTIVE_TYPES,
      EFFECTIVE_TYPE_DETAILED_DESCRIPTIONS,
      EFFECTIVE_SCENARIOS
    })
  }
}

</script>
